export const ru = ({
  permission_tag_general_info: {
    title: 'Общая информация',
    data: {
      name: 'Название',
      created: 'Создано',
      created_date: 'Дата создания',
    },
  },
}) as Record<string, unknown>;

export const en = ({
  permission_tag_general_info: {
    title: 'General information',
    data: {
      name: 'Title',
      created: 'Created',
      created_date: 'Date of creation',
    },
  },
}) as Record<string, unknown>;

export const esEs = ({
  permission_tag_general_info: {
    title: 'Información general',
    data: {
      name: 'Nombre',
      created: 'Creado',
      created_date: 'Fecha de creación',
    },
  },
}) as Record<string, unknown>;

export const ptBr = ({
  permission_tag_general_info: {
    title: 'Informações gerais',
    data: {
      name: 'Nome',
      created: 'Criado',
      created_date: 'Data de criação',
    },
  },
}) as Record<string, unknown>;
